import React from 'react';

export const ChevronRight = ({style}) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"  style={style}>
            <path d="M8.47547 20.3441C8.86597 20.7345 9.49907 20.7345 9.88947 20.344L17.5255 12.7072C17.916 12.3167 17.916 11.6836 17.5255 11.293L9.88947 3.65617C9.49907 3.26566 8.86597 3.26565 8.47547 3.65613C8.08497 4.04658 8.08497 4.67961 8.47537 5.07009L14.6975 11.293C15.088 11.6836 15.088 12.3167 14.6975 12.7072L8.47537 18.9301C8.08497 19.3206 8.08497 19.9536 8.47547 20.3441Z" fill="white"/>
        </svg>
    )
};
